import _regenerator from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { request, METHOD } from '@/utils/request';
export function querySystemNotice(_x, _x2, _x3) {
  return _querySystemNotice.apply(this, arguments);
}
function _querySystemNotice() {
  _querySystemNotice = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(page, limit, param) {
    var data;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          // 数据处理
          data = {
            currentNo: page,
            pageSize: limit,
            status: param.status,
            startDate: param.startDate,
            endDate: param.endDate,
            noticeType: param.noticeType,
            msgType: param.msgType
          };
          return _context.a(2, request("/systemNotice/querySystemNotice", METHOD.POST, data));
      }
    }, _callee);
  }));
  return _querySystemNotice.apply(this, arguments);
}
export function updateIsReadFlowableRecord(_x4) {
  return _updateIsReadFlowableRecord.apply(this, arguments);
}
function _updateIsReadFlowableRecord() {
  _updateIsReadFlowableRecord = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(id) {
    var data;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          // 数据处理
          data = {
            id: id
          };
          return _context2.a(2, request("/wxflow/updateIsReadFlowableRecord", METHOD.POST, data));
      }
    }, _callee2);
  }));
  return _updateIsReadFlowableRecord.apply(this, arguments);
}
export function queryMessageFlowableRecordById(_x5) {
  return _queryMessageFlowableRecordById.apply(this, arguments);
}
function _queryMessageFlowableRecordById() {
  _queryMessageFlowableRecordById = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(id) {
    var data;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          // 数据处理
          data = {
            id: id
          };
          return _context3.a(2, request("/wxflow/queryMessageFlowableRecordById", METHOD.GET, data));
      }
    }, _callee3);
  }));
  return _queryMessageFlowableRecordById.apply(this, arguments);
}